export const GET_ALL_MAIN_CATEGORY_DATA = "GET_ALL_MAIN_CATEGORY_DATA";
export const API_CALL_STATUS = "API_CALL_STATUS";
export const GET_LOAD_BUDGET_SOM_DATA = "GET_LOAD_BUDGET_SOM_DATA";
export const GET_LOAD_REMARKS_FOR_BUDGET = "GET_LOAD_REMARKS_FOR_BUDGET";
export const CLEAR_ALL_DATA = "CLEAR_ALL_DATA";
export const STATUS_UPDATE = "STATUS_UPDATE";
